import posthog from 'posthog-js';

import { posthogInitOptions, registerDeployProperties } from '@/lib/analytics';

// PostHog browser analytics, sharing a project with server-side capture.
//
// The variables come from `sst.config.ts` and are absent locally, keeping dev traffic
// out of the shared project, so a missing token is normal.

const projectToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
const host = process.env.NEXT_PUBLIC_POSTHOG_HOST;

if (!projectToken || !host) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(
      'PostHog analytics disabled: NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN and NEXT_PUBLIC_POSTHOG_HOST are not configured. This is expected for local development; set both to capture events against your own PostHog project.'
    );
  }
} else {
  posthog.init(projectToken, posthogInitOptions(host));

  registerDeployProperties();
}
